import * as cheerio from 'cheerio';

export function extractTocItems(html: string) {
    const $ = cheerio.load(html);
    const items: { id: string; text: string; tagName: string }[] = [];

    $('h1, h2, h3').each((_, el) => {
        if ('name' in el) {
            const tagName = el.name.toUpperCase();
            const text = $(el).text();
            let id = $(el).attr('id');

            if (!id) {
                id = encodeURIComponent(text.slice(0, 200).replace(/\s+/g, '-'));
                $(el).attr('id', id);
            }

            items.push({ id, text, tagName });
        }
    });

    return { tocItems: items };
}
